import clsx from "clsx";
import { FuseNavigationProps } from "../FuseNavigation";
import { FuseNavItemType } from "../types/FuseNavItemType";
import FuseNavVerticalItemBase from "./shared/FuseNavVerticalItemBase";

/**
 * FuseNavVerticalLayout1
 * Este componente é usado para renderizar navegações verticais usando
 * o componente List do Material-UI. Ele recebe as props FuseNavigationProps
 * e renderiza os componentes FuseNavItem conforme necessário.
 */
function FuseNavVerticalLayout1(props: Readonly<FuseNavigationProps>) {
	const { navigation, active, dense, className, onItemClick, aoAnteciparItem, checkPermission } = props;

	function handleItemClick(item: FuseNavItemType) {
		onItemClick?.(item);
	}

	return (
		<div className={clsx("navigation px-3", dense && "dense", `active-${active}-list`, className)}>
			{navigation.map((_item) => (
				<FuseNavVerticalItemBase
					key={_item.id}
					item={_item}
					nestedLevel={0}
					onItemClick={handleItemClick}
					aoAnteciparItem={aoAnteciparItem}
					checkPermission={checkPermission}
					dense={dense}
				/>
			))}
		</div>
	);
}

export default FuseNavVerticalLayout1;
